import { VehicleDamageAmountTypeParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleDamageAmount/getVehicleDamageAmountQuery.type';
import { vehicleDamageAmountQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleDamageAmount/getVehicleDamageAmountQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehicleDamageAmountQueryOptions = (
  params: VehicleDamageAmountTypeParams,
) =>
  queryOptions({
    queryKey: ['get_vehicle_damage_amount', params],
    queryFn: () => vehicleDamageAmountQueryFunction(params),
  });
